import { createApiQueryHook, IApiQueryFunction } from "@sol/sdk/utils/api";
import { mapRelationalValue, RelationalValue } from "@sol/sdk/utils/filters";

import { IBriefResource } from "../../briefs";
import { IAIChatMessage } from "../mutations/aiMessageSendMutation";

export type IAIHistoryQueryParameters = {
    brief: RelationalValue<IBriefResource>;
};

export type IAIHistoryQueryResult = {
    history: IAIChatMessage[];
    count: number;
};

export const aiHistoryQuery: IApiQueryFunction<IAIHistoryQueryParameters> = ({ brief }) => {
    const briefId = mapRelationalValue(brief);

    return {
        method: "GET",
        url: `/ai/history/${briefId}`,
    };
};

export const useAIHistoryQuery = createApiQueryHook<IAIHistoryQueryParameters, IAIHistoryQueryResult>(aiHistoryQuery);
